/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResourceUpdated
 */
export interface ResourceUpdated {
    /**
     * 
     * @type {string}
     * @memberof ResourceUpdated
     */
    id: string;
}

/**
 * Check if a given object implements the ResourceUpdated interface.
 */
export function instanceOfResourceUpdated(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ResourceUpdatedFromJSON(json: any): ResourceUpdated {
    return ResourceUpdatedFromJSONTyped(json, false);
}

export function ResourceUpdatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceUpdated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function ResourceUpdatedToJSON(value?: ResourceUpdated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

